<div [formGroup]="attributesFormGroup" class="attribute-group">
  <sc-flex vertical stretchContent>
    @for (attribute of attributeGroup.attributes; track attribute) {
      <sc-content-spacer vertical></sc-content-spacer>
      @if ('STRING' == attribute.type) {
        <mat-form-field appearance="fill">
          <mat-label><app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label></mat-label>
          <input matInput [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
        </mat-form-field>
      }
      @if ('TEXT' == attribute.type) {
        <mat-form-field appearance="fill">
          <mat-label><app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label></mat-label>
          <input matInput [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
        </mat-form-field>
      }
      @if ('NUMBER' == attribute.type) {
        <mat-form-field appearance="fill">
          <mat-label><app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label></mat-label>
          <input matInput numberInput [scale]="0" [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
        </mat-form-field>
      }
      @if ('DECIMAL' == attribute.type) {
        <mat-form-field appearance="fill">
          <mat-label><app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label></mat-label>
          <input matInput numberInput [scale]="3" [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
        </mat-form-field>
      }
      @if ('LOOKUP' == attribute.type) {
        <mat-form-field appearance="fill">
          <mat-label><app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label></mat-label>
          <mat-select  [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
            @for (value of attribute.values; track value) {
              <mat-option
                [value]="value.id+''">
                {{ value.value }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      @if ('BOOLEAN' == attribute.type) {
        <mat-checkbox [formControlName]="'attribute_'+attribute.id" [required]="attribute.mandatory === true">
          <app-dictionary-entry-label [model]="attribute.name"></app-dictionary-entry-label>
        </mat-checkbox>
      }
    }
  </sc-flex>
</div>
